<script setup lang="ts">
import AppTopNav from './AppTopNav.vue'
import AppSidebar from './AppSidebar.vue'
</script>

<template>
  <div class="min-h-screen bg-surface">
    <AppTopNav />
    <div class="flex pt-14">
      <AppSidebar />
      <main class="flex-1 lg:ml-52 px-6 lg:px-10 py-6">
        <slot />
      </main>
    </div>
  </div>
</template>
